import { Button } from "@project/components/ui/button";
import { FileSpreadsheet, Loader2 } from "lucide-react";

type CsvExportButtonProps = {
  onExport: () => void | Promise<void>;
  exporting?: boolean;
  disabled?: boolean;
  className?: string;
  size?: "default" | "sm" | "lg" | "icon";
};

export function CsvExportButton({
  onExport,
  exporting = false,
  disabled = false,
  className,
  size = "sm",
}: CsvExportButtonProps) {
  return (
    <Button
      type="button"
      variant="outline"
      size={size}
      disabled={disabled || exporting}
      className={`gap-1 rounded-xl ${className ?? ""}`.trim()}
      onClick={() => {
        void onExport();
      }}
    >
      {exporting ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <FileSpreadsheet className="h-4 w-4" />
      )}
      CSV
    </Button>
  );
}
